import apiBase from "./api-base";

export default class FoodDrink extends apiBase {
    constructor(store) {
        const path = "v1/FoodDrink";
        super(store, path);
    }

    list (filter, showProgress) {
        return this._request({
            action: "Get",
            method: "GET",
            params: filter,
            showProgress,
        });
    }

    create(model, showProgress) {
        return this._request({
            action: "Create",
            method: "POST",
            body: model,
            showProgress,
        });
    }

    update(model, id, showProgress) {
        return this._request({
            action: `Update/${id}`,
            method: "PUT",
            body: model,
            showProgress,
        });
    }
    UpdateItemChefPick(model, id, showProgress) {
        return this._request({
            action: `UpdateItemChefPick/${id}`,
            method: "PUT",
            body: model,
            showProgress,
        });
    }

    updateAvailable(model, id,  showProgress) {
        return this._request({
            action: `UpdateAvailble/${id}`,
            method: "PUT",
            body: model,
            showProgress,
        });
    }

    delete(id, model, showProgress) {
        return this._request({
            action: `Delete/${id}`,
            method: "DELETE",
            body: model,
            showProgress,
        });
    }

    uploadPhoto (model, id, showProgress) {
        return this._request({
            action: `UploadPhoto/${id}`,
            method: "POST",
            body: model,
            showProgress,
        });
    }

    deletePhoto (model, id, showProgress) {
        return this._request({
            action: `DeletePhoto/${id}`,
            method: "DELETE",
            body: model,
            showProgress,
        });
    }
}
